import PropTypes from 'prop-types';
import React from 'react';
import Attention from "../../icon-components/attention";
import IconCompleteCheckmark from "../../icon-components/complete-checkmark/complete-checkmark";
import IconInfo from "../../icon-components/info/info";
import IconClose from "../../icon-components/close/close";
var VARIANT_INFO = 'info';
var VARIANT_DANGER = 'danger';
var VARIANT_SUCCESS = 'success';
var VARIANT_WARNING = 'warning';
var CLASSNAME = 'frc-alert';

var getIconFromVariant = function getIconFromVariant(variant) {
  if (variant === VARIANT_SUCCESS) return React.createElement(IconCompleteCheckmark, null);
  if (variant === VARIANT_INFO) return React.createElement(IconInfo, {
    className: "".concat(CLASSNAME, "-info-icon")
  });
  var attentionStyle = variant === VARIANT_DANGER ? 'error' : 'incomplete';
  return React.createElement(Attention, {
    status: attentionStyle
  });
};
/**
 * This is the Alert component
 */


var Alert = function Alert(_ref) {
  var variant = _ref.variant,
      title = _ref.title,
      hasIcon = _ref.hasIcon,
      children = _ref.children,
      show = _ref.show,
      dismissible = _ref.dismissible,
      onDismiss = _ref.onDismiss;
  if (!show) return null;
  return React.createElement("div", {
    className: "".concat(CLASSNAME, " ").concat(CLASSNAME, "-variant-").concat(variant)
  }, React.createElement("div", {
    className: "".concat(CLASSNAME, "-inner")
  }, hasIcon && React.createElement("div", {
    className: "".concat(CLASSNAME, "-icon")
  }, getIconFromVariant(variant)), React.createElement("div", {
    className: "".concat(CLASSNAME, "-content")
  }, title && React.createElement("div", {
    className: "".concat(CLASSNAME, "-title")
  }, title), React.createElement("div", {
    className: "".concat(CLASSNAME, "-children")
  }, children)), dismissible && React.createElement("div", {
    onClick: onDismiss || null,
    className: "".concat(CLASSNAME, "-dismiss")
  }, React.createElement(IconClose, null))));
};

Alert.displayName = 'Alert';
Alert.propTypes = {
  /**
   * Show the variant icon in the alert.
   */
  show: PropTypes.bool,

  /**
   * Show the variant icon in the alert.
   */
  hasIcon: PropTypes.bool,

  /**
   * An optional title.
   */
  title: PropTypes.string,

  /**
   * Renders a properly aligned dismiss button.
   */
  dismissible: PropTypes.bool,

  /**
   * The theme of the button.
   *
   * You can use use a VARIANT_X constant too: `<Alert variant={Alert.VARIANT_INFO} />`
   *
   * @see See [React Bootstrap's Alert](https://react-bootstrap.github.io/components/alerts/#links)
   */
  variant: PropTypes.oneOf([VARIANT_INFO, VARIANT_DANGER, VARIANT_SUCCESS, VARIANT_WARNING]),

  /**
   * The content of the alert.
   */
  children: PropTypes.node.isRequired,

  /**
   * Callback when clicked on dismiss icon.
   */
  onDismiss: PropTypes.func
};
Alert.defaultProps = {
  hasIcon: true,
  show: true
};
Alert.VARIANT_INFO = VARIANT_INFO;
Alert.VARIANT_DANGER = VARIANT_DANGER;
Alert.VARIANT_SUCCESS = VARIANT_SUCCESS;
Alert.VARIANT_WARNING = VARIANT_WARNING;
export default Alert;